Cart.updates.freeShipping = function (data) {
    $('[data-element="cart"]')
        .filter('[data-type="free_shipping"]')
        .html(Format.price(data.price));

    $('[data-element="cart"]')
        .filter('[data-type="free_shipping_text"]')
        .html( data.text.replace('{2}', $('.js-shipping-text').data('cheapest-shipping')).replace('{3}', Format.price(data.price)) );
}

Spinner.template = "{{value}} {{append}}";

Form.buildSpinners = function() {
    Form.buildSpinnersInside('body');
}

Form.buildSpinnersInside = function(selector) {
    $.widget( "ui.spinner", $.ui.spinner, {
        _format: function(value) {
            let $elem = $(this.element),
                append = '';

            if ($elem.data('spinner-append')) {
                append = $elem.data('spinner-append');
            }

            return _.template(Spinner.template)({
                value: value,
                append: append
            });
        },
        _parse: function(value) {
            return parseInt(value);
        }
    });

    $(selector).find('input.ui-spinner').each(function() {
        const $spinner = $(this);

        if (!$spinner.data('uiSpinner')) {
            $(this).spinner(Spinner.options);
        }
    });
}

function check_hidden_inputs(elm) {
    const $registeredInputs = $(elm).closest('form').find('input[name="registered"]');

    if (!$(elm).is(":checked")) {
        $("#" + $(elm).attr("data-box")).addClass("hide");
        $registeredInputs.val(0);
    }
    else {
        $("#" + $(elm).attr("data-box")).removeClass("hide");
        $registeredInputs.val(1);
    }
}

function branchOpenings() {

}

$(function () {
    $('.branch-info__box[data-id="' + $('#branch_id').val() + '"]').addClass('is-active');

    $('#branch_id').on('change', function () {
        const id = $(this).val();

        $('.branch-info__box.is-active').removeClass('is-active');
        $('.branch-info__box[data-id="' + id + '"]').addClass('is-active');
    });

    // old stuff from modules.ctp
    $('input[name="shipping_id"]').bind('change', function () {
        const $form = $(".js-form-cart-modules");

        $('input[name="shipping_method"]').val($(this).data('name'));

        var payments = $(this).data('payments');
        $('input[name="payment_id"]').prop('disabled', false);
        $('input[name="payment_id"]').filter(function (index) {
            return _.indexOf(payments, parseInt($(this).val())) == -1;
        }).prop('disabled', true).prop('checked', false).trigger('change');

        if ($(this).val() != $('[name="branch_id"]').parents('.shopping-modules__item').find('[name="shipping_id"]').val()) {
            $('[name="branch_id"]:checked').prop('checked', false).trigger('change');
        }

        $('.js-fake-courier').toggleClass('is-selected', $(this).siblings().hasClass('is-courier'));
    });

    $('input[name="payment_id"]').on('change', function () {
        $('input[name="payment_method"]').val($(this).data('name'));
    });

    $('input[name="shipping_id"]:checked').trigger('change');

    // modules validate
    $('.js-form-cart-modules').on('submit', function (event) {
        event.preventDefault();
    }).validate({
        errorPlacement: function (error, element) {
            if (element.attr("type").match("checkbox")) {
                error.insertAfter(element.siblings("label"));
            } else {
                error.insertAfter(element);
            }
        },
        submitHandler: function (form) {
            let result = true;

            if (!$('[name="payment_id"]').is(':checked')) {
                $('#error-payment').fadeIn(500);
                result = false;
            } else {
                if ($('#error-payment').is(':visible')) { $('#error-payment').fadeOut(500); }
            }

            if (!$('[name="shipping_id"]').is(':checked')) {
                $('#error-shipping').fadeIn(500);
                result = false;
            } else {
                if ($('#error-shipping').is(':visible')) { $('#error-shipping').fadeOut(500); }

                // branch pickup
                if ($('[name="shipping_id"]:checked').parent().find('[name="branch_id"]').length && $('[name="branch_id"]').val() == '') {
                    $('#error-branch').fadeIn(500);

                    result = false;
                }
                else {
                    if ($('#error-branch').is(':visible')) { $('#error-branch').fadeOut(500); }
                }
            }

            if (!result) {
                $('.c-msg--error:visible').slideHere();
            }

            if (result) {
                $('.js-order-submit')
                    .prop('disabled', true)
                    .addClass('is-loading');

                form.submit();
            }
        }
    });

    $('.js-form-cart-modules').find('input[type="radio"]').on('change', function () {
        const $form = $(".js-form-cart-modules");

        $.post($form.data('update-action'), $form.serialize(), function (data) {
            const shipping = data.totals.shipping,
                payment = data.totals.payment,
                discount = data.totals.discount,
                isShippingSelected = $('input[name="shipping_id"]:checked').length > 0,
                isPaymentSelected = $('input[name="payment_id"]:checked').length > 0;

            Cart.updates.totals(data.totals);

            if (shipping) {
                $('.js-cart-recap-shipping')
                    .removeClass('is-green')
                    .html(Format.price(shipping));
            } else {
                $('.js-cart-recap-shipping')
                    .removeClass('is-green')
                    .html($('.js-cart-recap-shipping').data(isShippingSelected ? 'free' : 'empty'));

                if (isShippingSelected) {
                    $('.js-cart-recap-shipping').addClass('is-green');
                }
            }

            if (payment) {
                $('.js-cart-recap-payment')
                    .removeClass('is-green')
                    .html(Format.price(payment));
            } else {
                $('.js-cart-recap-payment')
                    .removeClass('is-green')
                    .html($('.js-cart-recap-payment').data(isPaymentSelected ? 'free' : 'empty'));

                if (isPaymentSelected) {
                    $('.js-cart-recap-payment').addClass('is-green');
                }
            }

            // $('.js-cart-recap-shipping').html(shipping ? Format.price(shipping) : $('.js-cart-recap-shipping').data('free'));
            // $('.js-cart-recap-payment').html(payment ? Format.price(payment) : $('.js-cart-recap-payment').data('free'));
            $('.js-recap-totals').html(Format.price(data.totals.total - shipping - payment - discount));
        }, "json");
    });

    $('.js-form-cart-modules-submit').on('click', function() {
        $('.js-form-cart-modules').submit();
    })

    // reg form
    if ($('.js-form-reg').length > 0) {
        check_hidden_inputs($("#order-registered, #customer-registered"));

        $("#order-registered, #customer-registered").change(function () {
            check_hidden_inputs($(this));
        });
    }

    $(document).on('focus', 'input.ui-spinner-input', function(e, ui) {
        $(this).val(parseInt($(this).val())).select();
    });

    $(document).on('spinchange blur', 'input.ui-spinner-input', function(e, ui) {
        const $spinnerInput = $(this),
            max = parseInt($spinnerInput.attr('max')),
            min = parseInt($spinnerInput.attr('min')),
            step = $spinnerInput.spinner('option', 'step');

        let value = parseInt($spinnerInput.val()),
            append = '';

        if ($spinnerInput.data('spinner-append')) {
            append = $spinnerInput.data('spinner-append');
        }

        if (value > max) {
            value = max;
        }

        if (value < min) {
            if (step && min < step) {
                value = step;
            } else {
                value = min;
            }
        }

        $spinnerInput.val(_.template(Spinner.template)({
            value: value,
            append: append
        }));
    });

    $('.js-import-form-input').on('change', function() {
        $('.js-import-form').submit();

        $(this).prop('disabled', true);
        $(this).siblings('.c-btn').addClass('is-loading');
    });

    $('.js-form-voucher').validate({
        submitHandler: function (form) {
            $(form).find('[type="submit"]').prop('disabled', true).addClass('is-loading');

            form.submit();
        }
    });
});
